import React from 'react';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import Navbar from './components/Navbar';
import Hero from './sections/Hero';
import About from './sections/About';
import Skills from './sections/Skills';
import Experience from './sections/Experience';
import Activities from './sections/Activities';
import Projects from './sections/Projects';
import Awards from './sections/Awards';
import Contact from './sections/Contact';

const Footer: React.FC = () => {
  const { t } = useLanguage();
  
  return (
      <footer className="py-8 px-6 bg-dark-surface border-t border-gray-800">
        <div className="container mx-auto text-center">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 mb-4">
            <a 
              href="mailto:hyunwoo892579@gmail.com" 
              className="text-gray-400 hover:text-blue-400 transition-colors flex items-center gap-2"
            >
              <span>hyunwoo892579@gmail.com</span>
            </a>
            <span className="text-gray-600 hidden md:inline">|</span>
            <a 
              href="tel:01049177671" 
              className="text-gray-400 hover:text-green-400 transition-colors flex items-center gap-2"
            >
              <span>010-4917-7671</span>
            </a>
          </div>
        <p className="text-gray-400">{t('footer.copyright')}</p>
        </div>
      </footer>
  );
};

function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-dark-bg">
        <Navbar />
        <Hero />
        <About />
        <Skills />
        <Experience />
        <Activities />
        <Projects />
        <Awards />
        <Contact />
        <Footer />
    </div>
    </LanguageProvider>
  );
}

export default App;
